<template>
  <span class="count ml-1" v-if="wishListCount">{{ wishListCount }}</span>
</template>

<script>
export default {
  computed: {
    wishListCount() {
      return this.$store.getters.wishListCount;
    },
  },
};
</script>
